import { useState } from 'react';
import { Check, Edit, RotateCcw, Trash2 } from 'lucide-react';
import type { Idea } from '../../types';

// A partir de aquí las anotaciones se recortan en la tarjeta con "Ver más".
const NOTAS_LARGAS_CARACTERES = 280;
const NOTAS_LARGAS_LINEAS = 5;

interface Props {
  idea: Idea;
  onAlternarHecha: (idea: Idea) => void;
  onEditar: (idea: Idea) => void;
  onEliminar: (idea: Idea) => void;
}

export function TarjetaIdea({ idea, onAlternarHecha, onEditar, onEliminar }: Props) {
  const [expandida, setExpandida] = useState(false);
  const notasLargas =
    idea.notas.length > NOTAS_LARGAS_CARACTERES ||
    idea.notas.split('\n').length > NOTAS_LARGAS_LINEAS;

  return (
    <div
      className={`rounded-xl shadow-lg p-6 transition-shadow ${
        idea.hecha ? 'bg-gray-50 opacity-70' : 'bg-white hover:shadow-xl'
      }`}
    >
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div className="flex-1 min-w-0">
          <h3
            className={`text-xl font-bold mb-2 break-words ${
              idea.hecha ? 'text-gray-500 line-through' : 'text-gray-800'
            }`}
          >
            {idea.titulo}
          </h3>
          {idea.notas && (
            <div className="text-gray-600">
              <p
                className={`text-sm text-gray-500 whitespace-pre-wrap break-words ${
                  notasLargas && !expandida ? 'line-clamp-5' : ''
                }`}
              >
                {idea.notas}
              </p>
              {notasLargas && (
                <button
                  onClick={() => setExpandida(!expandida)}
                  className="text-sm text-amber-600 hover:text-amber-700 font-medium mt-1"
                >
                  {expandida ? 'Ver menos' : 'Ver más'}
                </button>
              )}
            </div>
          )}

          <div className="flex gap-2 mt-4 flex-wrap">
            {idea.hecha ? (
              <button
                onClick={() => onAlternarHecha(idea)}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <RotateCcw size={16} />
                Reabrir
              </button>
            ) : (
              <button
                onClick={() => onAlternarHecha(idea)}
                className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <Check size={16} />
                Marcar hecha
              </button>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onEditar(idea)}
            className="text-blue-600 hover:text-blue-800 p-2 hover:bg-blue-50 rounded-lg transition-colors"
            title="Editar / anotaciones"
          >
            <Edit size={20} />
          </button>
          <button
            onClick={() => onEliminar(idea)}
            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
            title="Borrar de la lista"
          >
            <Trash2 size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
